import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_BASE_URL } from "../../config";

export const apiSlice = createApi({
	reducerPath: "api",
	baseQuery: fetchBaseQuery({
		baseUrl: API_BASE_URL,
		prepareHeaders: (headers, { getState }) => {
			const token = getState().auth.token;

			if (token) {
				headers.set("Authorization", `Bearer ${token}`);
			}
			return headers;
		},
	}),
	tagTypes: [
		"User",
		"ClassLogs",
		"Students",
		"Teachers",
		"Subjects",
		"Departments",
		"Class",
		"ClassDepartments",
		"Absences",
	],
	endpoints: (builder) => ({}),
});
